export default "__VITE_ASSET__caa1f31b__"